export const AdminSalesListingDashboards = {
  AdminSalesListingDashboards: 
  {
    permissionsId: '103383c1-c489-465e-ee41-08da65738802',
    permissionsName: 'Admin Sales Listing Manager',
    componentsId: null,
    components: null
  }
} ;
